import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ca4cbb4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = { style: {"background":"white","size":"12px"} }
const _hoisted_3 = { style: {"font-size":"12px","color":"gray"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"padding-top":"65px"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_content, { style: { background: '#fff', padding: '24px', margin: 0, minHeight: '280px' } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_breadcrumb, {
                separator: ">",
                style: {"margin":"0px 0px 20px 20px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_breadcrumb_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, { to: '/admin/track' }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 路径管理 ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_breadcrumb_item, null, {
                    default: _withCtx(() => [
                      _createTextVNode("步骤管理")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_breadcrumb_item, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.track.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                layout: "inline",
                style: {"margin":"0px 0px 20px 20px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleQuery()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 查询 ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.add()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 新增 ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: '/step?trackId=' + _ctx.trackId,
                        slots: "a",
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, { type: "primary" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 详情 ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_table, {
            columns: _ctx.columns,
            "data-source": _ctx.steps,
            loading: _ctx.loading
          }, {
            ebooks: _withCtx(({ record }) => [
              _createVNode(_component_a_list, {
                "item-layout": "horizontal",
                "data-source": record.ebooks
              }, {
                renderItem: _withCtx(({ item }) => [
                  _createVNode(_component_a_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_list_item_meta, null, {
                        title: _withCtx(() => [
                          _createElementVNode("a", {
                            href: '/doc?ebookId=' + item.id,
                            target: "_blank"
                          }, _toDisplayString(item.name), 9, _hoisted_1)
                        ]),
                        avatar: _withCtx(() => [
                          _createVNode(_component_a_layout, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_avatar, {
                                src: item.coverUrl,
                                shape: "square",
                                size: 48
                              }, null, 8, ["src"]),
                              _createElementVNode("span", _hoisted_2, "序号: " + _toDisplayString(item.sort), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        description: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(item.description), 1),
                          _createElementVNode("p", null, [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              size: "small",
                              ghost: "",
                              onClick: ($event: any) => (_ctx.editEbook(record, item))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("编辑")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_a_popconfirm, {
                              title: "删除后不可恢复，确认删除?",
                              "ok-text": "是",
                              "cancel-text": "否",
                              onConfirm: ($event: any) => (_ctx.handleDeleteEbook(record, item))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  size: "small",
                                  ghost: "",
                                  danger: "",
                                  style: {"margin-left":"5px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("删除")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["onConfirm"])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["data-source"])
            ]),
            action: _withCtx(({ record }) => [
              _createVNode(_component_a_space, { size: "small" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: ($event: any) => (_ctx.addEbook(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_PlusOutlined),
                      _createTextVNode("电子书 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: ($event: any) => (_ctx.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 编辑 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "删除后不可恢复，确认删除?",
                    "ok-text": "是",
                    "cancel-text": "否",
                    onConfirm: ($event: any) => (_ctx.handleDelete(record.id))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        danger: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 删除 ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["columns", "data-source", "loading"]),
          _createVNode(_component_a_modal, {
            title: "步骤表单",
            open: _ctx.modalVisible,
            "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalVisible) = $event)),
            "confirm-loading": _ctx.modalLoading,
            onOk: _ctx.handleModalOk
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                model: _ctx.step,
                "label-col": { span: 6 },
                "wrapper-col": { span: 18 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.step.name,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step.name) = $event)),
                        allowClear: true
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "描述" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.step.description,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step.description) = $event)),
                        type: "textarea",
                        allowClear: true
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "序号" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.step.sort,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step.sort) = $event)),
                        type: "number",
                        min: 1,
                        max: 1000,
                        allowClear: true
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }, 8, ["open", "confirm-loading", "onOk"]),
          _createVNode(_component_a_modal, {
            title: "电子书表单",
            open: _ctx.modalEbookVisible,
            "onUpdate:open": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalEbookVisible) = $event)),
            "confirm-loading": _ctx.modalEbookLoading,
            onOk: _ctx.handleEbookModalOk
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                model: _ctx.ebook,
                "label-col": { span: 6 },
                "wrapper-col": { span: 18 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "分类" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_cascader, {
                        value: _ctx.categoryIds,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.categoryIds) = $event)),
                        "field-names": { label: 'name', value: 'id', children: 'children' },
                        options: _ctx.level1,
                        onChange: _ctx.changeCategory
                      }, null, 8, ["value", "options", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "电子书" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.ebook.id,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ebook.id) = $event)),
                        onChange: _ctx.handleChangeSelect,
                        allowClear: true
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ebook.ebooksOption, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: item.id,
                              value: item.id
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(item.name), 1),
                                _createTextVNode("   "),
                                _createElementVNode("span", _hoisted_3, _toDisplayString(item.description), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "排序" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.ebook.sort,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ebook.sort) = $event)),
                        type: "number",
                        min: 1,
                        allowClear: true
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }, 8, ["open", "confirm-loading", "onOk"])
        ]),
        _: 1
      }),
      _createVNode(_component_TheFooter)
    ]),
    _: 1
  }))
}